(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
(function() {
  var loadRelatedProducts = function() {
    var section = document.querySelector('.related-products');
    if (!section) return;
    var xhr = new XMLHttpRequest();
    xhr.open('GET', section.dataset.url);
    xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 300) {
        var tmp = document.createElement('div');
        tmp.innerHTML = xhr.response;
        var inner = tmp.querySelector('.related-products');
        if (inner) {
          section.innerHTML = inner.innerHTML;
          initRelatedProducts();
          initRpSlider();
          if (typeof theme !== 'undefined' && theme.initAnimateOnScroll) {
            theme.initAnimateOnScroll();
          }
        }
      }
    };
    xhr.send();
  };

  /* ── MOBILE SLIDER (prev/next + dots) ──────────────────────── */
  var initRpSlider = function() {
    if (window.innerWidth >= 768) return;

    var sliders = document.querySelectorAll('[id^="rp-slider-"]');
    sliders.forEach(function(slider) {
      var sectionId = slider.id.replace('rp-slider-', '');
      var dotsWrap  = document.getElementById('rp-dots-' + sectionId);
      var prevBtn   = document.getElementById('rp-prev-' + sectionId);
      var nextBtn   = document.getElementById('rp-next-' + sectionId);
      if (!slider || !dotsWrap) return;

      var cards = Array.prototype.slice.call(slider.querySelectorAll('.rp-card'));
      if (cards.length <= 1) return;

      var currentIndex = 0;
      var dots = [];

      function getCardWidth() {
        if (!cards[0]) return 0;
        var gap = parseFloat(getComputedStyle(slider).gap) || 0;
        return cards[0].offsetWidth + gap;
      }

      function getVisibleCount() {
        if (!cards[0]) return 1;
        return Math.max(1, Math.round(slider.clientWidth / cards[0].offsetWidth));
      }

      function getDotCount() {
        return Math.max(1, cards.length - getVisibleCount() + 1);
      }

      function applyDotStyle(dot, isActive) {
        dot.style.background     = isActive ? '#FAB10D' : 'rgba(0,0,0,0.18)';
        dot.style.width          = isActive ? '20px' : '8px';
        dot.style.maxWidth       = isActive ? '20px' : '8px';
        dot.style.borderRadius   = isActive ? '4px' : '50%';
        dot.style.minWidth       = '8px';
        dot.style.height         = '8px';
        dot.style.minHeight      = '8px';
        dot.style.maxHeight      = '8px';
        dot.style.padding        = '0';
        dot.style.margin         = '0';
        dot.style.border         = 'none';
        dot.style.cursor         = 'pointer';
        dot.style.display        = 'block';
        dot.style.flexShrink     = '0';
      }

      function updateDots(activeIdx) {
        dots.forEach(function(d, i) {
          var active = i === activeIdx;
          d.classList.toggle('is-active', active);
          applyDotStyle(d, active);
        });
      }

      function scrollToIndex(i) {
        var dotCount = getDotCount();
        currentIndex = Math.max(0, Math.min(i, dotCount - 1));
        if (currentIndex === dotCount - 1) {
          slider.scrollTo({ left: slider.scrollWidth - slider.clientWidth, behavior: 'smooth' });
        } else {
          slider.scrollTo({ left: getCardWidth() * currentIndex, behavior: 'smooth' });
        }
        updateDots(currentIndex);
      }

      function buildDots() {
        dotsWrap.innerHTML = '';
        dots = [];
        var count = getDotCount();
        for (var i = 0; i < count; i++) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'rp-dot' + (i === 0 ? ' is-active' : '');
          btn.setAttribute('aria-label', 'Produit ' + (i + 1));
          applyDotStyle(btn, i === 0);
          (function(idx) {
            btn.addEventListener('click', function() { scrollToIndex(idx); });
          })(i);
          dotsWrap.appendChild(btn);
          dots.push(btn);
        }
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { scrollToIndex(currentIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { scrollToIndex(currentIndex + 1); });

      /* Sync dots sur scroll manuel */
      var scrollTimer;
      slider.addEventListener('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() {
          var dotCount = getDotCount();
          var maxScroll = slider.scrollWidth - slider.clientWidth;
          if (slider.scrollLeft >= maxScroll - 2) {
            currentIndex = dotCount - 1;
          } else {
            var cw = getCardWidth();
            if (cw) currentIndex = Math.min(Math.round(slider.scrollLeft / cw), dotCount - 1);
          }
          updateDots(currentIndex);
        }, 50);
      }, { passive: true });

      /* Rebuild si rotation écran */
      var resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          if (window.innerWidth >= 768) return;
          buildDots();
          currentIndex = 0;
          slider.scrollTo({ left: 0, behavior: 'instant' });
        }, 200);
      });

      buildDots();
    });
  };

  var initRelatedProducts = function() {
    document.querySelectorAll('.rp-quick-add:not(.rp-quick-add--soldout)').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var variantId = btn.dataset.variantId;
        if (!variantId) return;
        var originalHTML = btn.innerHTML;
        btn.disabled = true;
        btn.style.opacity = '0.7';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><polyline points="20 6 9 17 4 12"/></svg> Ajouté !';
          btn.style.opacity = '1';
          var aa = window.theme && window.theme.settings && window.theme.settings.after_add_to_cart;
          if (aa === 'page') {
            window.location.href = '/cart';
          } else {
            document.documentElement.dispatchEvent(
              new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: { openDrawer: true } })
            );
          }
          setTimeout(function() {
            btn.innerHTML = originalHTML;
            btn.disabled = false;
          }, 2000);
        })
        .catch(function() {
          btn.innerHTML = originalHTML;
          btn.disabled = false;
          btn.style.opacity = '1';
        });
      });
    });
  };

  document.addEventListener('shopify:section:load', function(e) {
    if (document.querySelector('[data-section-id="' + e.detail.sectionId + '"].related-products')) {
      loadRelatedProducts();
    }
  });

  loadRelatedProducts();
  initRelatedProducts();
  initRpSlider();
})();

  } catch(e) { console.error(e); }
})();
})();
